/* Verolae · LP Offer CTA — countdown
   Reproduces the GemPages "Countdown Timer" element (assets.gemcommerce.com/assets-v2/gp-countdown-v7-5.js)
   used in the offer card of the source site landing pages, with the source configuration:
     behaviour "evergreen", 0 h 7 min 25 s, minutes + seconds only (no week/day/hour), empty unit labels,
     loopAfterFinish false, autoHideWhenTimeout false, redirect "stay-on-page".
   Evergreen = the countdown starts the first time a visitor sees it and the deadline is remembered in the
   visitor's browser, so reloading / navigating does not reset it; at zero it stays at 00 : 00.
   The GemPages script itself is not part of the source download, so the persistence key/format is ours
   (localStorage "verolae-lp-offer-cta:<section id>:<duration>"); the visible behaviour is the same.
   The source's second script (gp-button-v7-5.js) only turns the CTA into a link; the CTA is a plain <a>.
   Nothing is persisted inside the theme editor so merchants always preview a fresh timer. */
(function () {
  if (window.customElements.get('verolae-lp-offer-countdown')) return;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  class VerolaeLpOfferCountdown extends HTMLElement {
    connectedCallback() {
      this.minutesEl = this.querySelector('[data-countdown-minutes]');
      this.secondsEl = this.querySelector('[data-countdown-seconds]');
      if (!this.minutesEl || !this.secondsEl) return;

      this.duration = Math.max(0, parseInt(this.dataset.duration, 10) || 0);
      this.expiry = this.dataset.expiry || 'zeros';
      this.evergreen = this.dataset.evergreen === 'true' && !(window.Shopify && window.Shopify.designMode);
      this.storageKey = 'verolae-lp-offer-cta:' + (this.dataset.sectionId || '') + ':' + this.duration;
      this.row = this.closest('[data-countdown-row]') || this;
      this.row.style.display = '';

      this.expired = false;
      this.deadline = this.readDeadline(false);
      this.stop();
      this.tick();
      this.timer = window.setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      this.stop();
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    /* Evergreen: reuse the deadline stored for this visitor (also when it already passed, so the timer
       stays at 00 : 00 like the source); otherwise now + duration, stored when evergreen. */
    readDeadline(forceNew) {
      var now = Date.now();
      if (this.evergreen && !forceNew) {
        var stored = NaN;
        try {
          stored = parseInt(window.localStorage.getItem(this.storageKey), 10);
        } catch (e) {
          /* storage unavailable */
        }
        if (!isNaN(stored) && (stored > now || this.expiry !== 'restart')) return stored;
      }
      var deadline = now + this.duration * 1000;
      if (this.evergreen) {
        try {
          window.localStorage.setItem(this.storageKey, String(deadline));
        } catch (e) {
          /* storage unavailable */
        }
      }
      return deadline;
    }

    tick() {
      var remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      /* Hours are disabled in the source, so the first unit is total minutes. */
      this.minutesEl.textContent = pad(Math.floor(remaining / 60));
      this.secondsEl.textContent = pad(remaining % 60);
      if (remaining <= 0) this.onExpire();
    }

    onExpire() {
      if (this.expiry === 'restart' && this.duration > 0) {
        this.deadline = this.readDeadline(true);
        return;
      }
      if (this.expired) return;
      this.expired = true;
      this.stop();
      if (this.expiry === 'hide') this.row.style.display = 'none';
      /* 'zeros' (source behaviour): keep showing 00 : 00 */
    }
  }

  window.customElements.define('verolae-lp-offer-countdown', VerolaeLpOfferCountdown);
})();
